// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","774":"framework","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"ed14a7abe63d09a3f1d0","678":"8264bb54d4983fa6d072","774":"45df31e08bbd8e79d801","883":"95e6271a6536725aa9fe"}[chunkId] + ".js";
};